import { doGet, doPut } from "../api/baseAPI";
import { GROLOG_URL } from "../constant/apiConstant";

export const getDetail = async (token, api_contract, id) => {
  const url = `${GROLOG_URL}/${api_contract}/${id}`;
  let result = { data: undefined, ok: false }

  try {
    const response = await doGet(token, url, null);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data
    }
  } catch (error) {
    console.log(error);
  }

  return result
}

export const getList = async (token, api_contract, params ) => {
  const url = `${GROLOG_URL}/${api_contract}`;
  let result = { data: undefined, ok: false };

  try {
    const response = await doGet(token, url, params);
    if (response) {
      result.ok = true;
      result.data = response?.data?.payload?.data;
    }
  } catch (error) {
    return error
  }
  return result;
}

export const updateData = async (token, id, data) => {
  const result = { status: false, message: undefined }
  const url = `${GROLOG_URL}/company-profile/${id}`

  try {
    const res = await doPut(url, token, data);
    if (res) {
      result.status = true
      result.message = res.data.payload.message
    } else {
      result.status = false
      result.message = res.data.payload.message
    }
  } catch (error) {
    result.message = error.response.data.payload.message
    // checkValidationToken(error, token, refresh_token, dispatch)
  }

  return result
}

export const doUpdate = async (token, id, data, api_contract) => {
  const result = { status: false, message: undefined }
  const url = `${GROLOG_URL}/${api_contract}/${id}`

  try {
    const res = await doPut(url, token, data);
    if (res) {
      result.status = true
      result.message = res.data.payload.message
    } else {
      result.status = false
      result.message = res.data.payload.message
    }
  } catch (error) {
    result.message = error.response.data.payload.message
    // checkValidationToken(error, token, refresh_token, dispatch)
  }

  return result
}

export const getInitiate = async (token, api_contract, params) => {
  const url = `${GROLOG_URL}/${api_contract}`;
  let result = { initiate: undefined, ok: false }

  try {
    const response = await doGet(token, url, params);
    if (response) {
      result.ok = true;
      result.initiate = response?.data?.payload?.data
    }
  } catch (error) {
    console.log(error);
  }

  return result
}